const STORAGE_TIME = {
  HOURS: {
    ONE: 3600,
    TWO: 7200,
  },
  DAYS: {
    TWO: 172_800,
  },
  MONTHS: {
    THREE: 7_776_000,
  },
};

const maxAge = STORAGE_TIME.MONTHS.THREE; // default

const cookies = reactive({
  adaptive_title: useCookie("adaptive_title", { maxAge }),
  api_unavailable: useCookie<boolean | undefined>("api_unavailable", { maxAge: STORAGE_TIME.HOURS.ONE }),
  pre_token: useCookie("pre_token", { maxAge }),
  validationToken: useCookie("validationToken", { maxAge }),
  showValidationToken: useCookie<boolean | undefined>("showValidationToken", { maxAge: STORAGE_TIME.DAYS.TWO }),
  user_token: useCookie("user_token", { maxAge }),
  registrationToken: useCookie("registrationToken", { maxAge }),
  custom_platform_account_id: useCookie("custom_platform_account_id", { maxAge }),
  custom_platform_alias: useCookie("custom_platform_alias", { maxAge }),
  device_platform_alias: useCookie("device_platform_alias", { maxAge }),
  equals_country_region_site: useCookie<boolean | undefined>("equals_country_region_site", { maxAge }),
  from_url: useCookie("from_url", { maxAge: STORAGE_TIME.DAYS.TWO }),
  source_key: useCookie("source_key", { maxAge }),
  prohibit_background_showcase: useCookie<boolean | undefined>("prohibit_background_showcase", { maxAge: STORAGE_TIME.HOURS.TWO }),
  region_id: useCookie<number | string | undefined>("region_id", { maxAge }),
  sms_confirmation: useCookie<boolean | undefined>("sms_confirmation", { maxAge }),
  use_alternative_settings: useCookie<boolean | undefined>("use_alternative_settings", { maxAge }),
  yandex_client_id: useCookie("yandex_client_id", { maxAge }),
  telephone: useCookie("telephone", { maxAge }),
});

export default () => cookies;
